import React from 'react';

import { UiComponent, UserGroupComponent } from 'components';

function Register() {
  return (
    <>
      <UiComponent.PageTitle>회원 그룹 만들기</UiComponent.PageTitle>
      <UserGroupComponent.Register />
    </>
  );
}

export default Register;
